<template>
    <div class="page home">
        <Ham :on="on" @select="hamSelect" />
        <VHeader type="ham" :avatar="true" @avatar="showAcccount()"/>
        <div class="page-content">
            <p class="btn" @click="redeem()" style="line-height: 90px;margin: 40px 15px;display: none;">redeem</p>
            <p class="btn" @click="loyalty()" style="line-height: 90px;margin: 40px 15px;display: none;" >loyalty</p>
            <p class="btn" @click="pushPage('scan')" style="line-height: 90px;margin: 40px 15px;">SCAN</p>
        </div>  
    </div>
</template>

<script>

import VHeader from '@/components/VHeader.vue'
import Ham from '@/components/Ham.vue'
import Loyalty from '@/components/Loyalty.vue'

import { mapMutations, mapActions } from 'vuex'
import Alert from '@/utils/Alert.js'
import WebSoc from '@/utils/WebSoc.js'
const URL = 'wss://api.survey-vip.com'

export default {
    name: 'home',
    components: {
        VHeader,
        Ham
    },
    computed: {
        auth () { return this.$store.state.auth }
    },
    data () {
        return {
            on: false,
            started: false,
            AddMembers: true,
            name: '',
            email: '',
            mobile: ''
        }
    },
    computed: {
        survey () { return this.$store.state.survey },
        TsCs () { return this.$store.state.TsCs },
    },
    mounted () {
        this.initWS();
        if ( !this.auth ) this.pushPage('auth');
    },
    methods: {
        showAcccount () {
            this.pushPage('account');
        },
        redeem () {
            console.log('show redeem')
            this.pushPage('redeem');
        },
        loyalty () {
            console.log('show loyalty');
            this.pushPage('loyalty');
        },
        terms () {
            console.log('getTerms');
        },
        signUp () {
            console.log('signUp');
        },
        initWS () {
            var that = this;
            var session = false;
            var _id, id, user_id, userId;
            try {
                id = localStorage.id;
                _id = localStorage._id;
                user_id = localStorage.user_id;
                userId = localStorage.userId;
            } catch(e) {

            }
            var connectURL = URL+'/jb-connect/'
            if ( id && _id ) { connectURL += '/'+_id+'/'+id }
                connectURL += '?id='+encodeURIComponent(location.href)
                if ( user_id && userId ) connectURL += '&user_id='+user_id+'&userId='+userId; 
            WebSoc(connectURL,{
                onopen ( ws ) {

                    if ( this.started ) return;
                    try {
                        var loyalty_id = localStorage.loyalty_id;
                        var loyaltyId = localStorage.loyaltyId;
                    } catch(e) {

                    } 

                    if ( loyalty_id && loyaltyId ) {

                        ws.SEND({ t: 'reAuthLoyalty', data: { loyalty_id, loyaltyId }},resp => {
                            if ( resp.success ) { 
                                that.setValue({ k: 'auth', v: resp.auth }) 
                            }
                        })
                    }
                },
                onmessage ( msg ) {
                    console.log('onmessage',msg);
                    that.wsAction(msg);
                }  
            })

        },
        hamSelect ( page ) {
            this.on = false;
            this.pushPage(page);
            return;
            if ( page == 'terms' ) {
                this.$emit('showTerms');
            }
        },
        ...mapMutations([
            'pushPage',
            'setValue'
        ]),
        ...mapActions([
            'wsAction'
        ]),
        approve () {
            this.pushPage('approve');
        }
    }
}

</script>

<style lang="scss">
.page.home {
    background-color: white;
}    
.page.home .page-content {
    
    h1 {
        display: none;
        width: 80%;
        margin: 40px 10%;
        text-align: center;
        line-height: 1.5;
    }
}
</style>